import _ from 'lodash';

import createModel, { prop } from './lib/create_model';
import CustomerTypingState from 'models/customer_typing_state';
import { formatPhoneNumber } from 'models/phone_number';
import InteractionType from 'models/interaction_type';
import RoutingQueueItem, { AgentParticipantStatus, RoutingStatus } from './routing_queue_item';

const SessionCustomer = createModel({
  modelName: 'SessionCustomer',

  properties: {
    id: prop(String).isRequired,
    name: prop(String),
  },

  updateName(name) {
    this.name = name;
  },

  statics: {
    create(attrs) {
      return new this(_.assign({}, attrs));
    },
  },
});

export default createModel({
  modelName: 'ActiveSession',

  properties: {
    id: prop(String).isRequired, // RoutingQueueItem id
    messageText: prop(String),
    customer: prop(SessionCustomer).isRequired,
    queueItem: prop(RoutingQueueItem).isRequired,
    readTo: prop(String),
    conversationUpdatedAt: prop(String),
    typingState: prop(CustomerTypingState).default(() => new CustomerTypingState()),
  },

  conversationId() {
    return this.queueItem.conversationId;
  },

  accept(agentId) {
    this.queueItem.updateStatus(RoutingStatus.ACTIVE);
    this.queueItem.updateParticipantStatus(agentId, AgentParticipantStatus.ACTIVE);
  },

  isUnread() {
    if (!this.conversationUpdatedAt) {
      return false;
    }
    return new Date(this.conversationUpdatedAt) > new Date(this.readTo);
  },

  setTypingState(typingState) {
    this.typingState = typingState;
  },

  getCustomerDisplayName() {
    if (this.customer.name) {
      return this.customer.name;
    }

    let latestSession = this.queueItem.getLatestSession();
    switch (_.get(latestSession, 'type')) {
      case InteractionType.ABANDONED_CALL:
      case InteractionType.VOICEMAIL:
        return formatPhoneNumber(latestSession.customerIdentifier);
      case InteractionType.CHAT:
      case InteractionType.SMS:
        return formatPhoneNumber(latestSession.customerIdentifier) || 'Customer';
      case InteractionType.EMAIL:
      case InteractionType.FB_MESSENGER:
      case InteractionType.TWITTER:
      case InteractionType.WHATSAPP:
      default:
        return 'Customer';
    }
  },

  update(attrs) {
    _.assign(this, _.omit(attrs, 'id'));
  },

  updateCustomerName(name) {
    this.customer.updateName(name);
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export { SessionCustomer };



// WEBPACK FOOTER //
// ./src/scripts/domain/models/active_session.js